import { createAsyncThunk } from "@reduxjs/toolkit";
import { normalize } from "normalizr";
import coreAPIs from "services/api/core";
import { show } from "store/schemas";

export const getNewsShows = createAsyncThunk("newsShows/getNewsShows", async (payload) => {
  try {
    const response = await coreAPIs.getNewsShows(payload);
    const hasItems =
      response.data?.data?.items && Array.isArray(response.data.data.items) && response.data.data.items.length > 0;

    return {
      ...response.data,
      ...(response.data.statusCode === 200 && hasItems
        ? normalize(response.data.data.items, [show])
        : { entities: { show: {} }, result: [] }),
    };
  } catch (error) {
    console.error("Error fetching news shows:", error);
    throw error;
  }
});

export const getNewsShowById = createAsyncThunk("newsShows/getNewsShowById", async (payload) => {
  try {
    const response = await coreAPIs.getNewsShowById(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createNewsShow = createAsyncThunk("newsShows/createNewsShow", async (payload) => {
  try {
    const response = await coreAPIs.createNewsShow(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteNewsShow = createAsyncThunk("newsShows/deleteNewsShow", async (payload) => {
  try {
    const response = await coreAPIs.deleteNewsShow(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateNewsShow = createAsyncThunk("newsShows/UpdateNewsShow", async (payload) => {
  try {
    const response = await coreAPIs.updateNewsShow(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
